// exports

export * from './badge';
export { BadgeContainer } from 'src/app/components/lib/badge-v2/badge.styles';
